import PropTypes from 'prop-types'
import React, { Component } from 'react'
import LineLabel from './components/LineLabel/LineLabel';
import './style.scss'

let canvas, context;

export class AnswerType6 extends Component {
  static propTypes = {}
  constructor(props) {
    super(props)
    this.ref = React.createRef();
    this.state = {
       
    }
  }

  moveLine = (s_x, s_y, e_x, e_y) => {
    try {
      context.beginPath();
      context.setLineDash([8, 5]);
      context.moveTo(s_x, s_y);
      context.lineTo(e_x, e_y);
      context.stroke();
      context.closePath();
    } catch (error) {
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps){
    const { answers } = nextProps;
    const items = answers.variants || [];
    context.clearRect(0,0,canvas.width,canvas.height);
    items.forEach(item => {
      this.moveLine(item.startX, item.startY, item.endX, item.endY)
    })
  }

  componentDidMount(){
    if(this.ref.current){
      canvas = this.ref.current;
      context = canvas.getContext("2d");
      const { answers } = this.props;
      const items = answers.variants || [];
      items.forEach(item => {
        this.moveLine(item.startX, item.startY, item.endX, item.endY)
      })
    }
  }
  

  render() {
    const { answers } = this.props;
    const items = answers.variants || [];
    return (
      <div className='AnswerType6Style'>
        <div className='blockAnswers' style={{backgroundImage: `url(${answers.image})`}}>
          <canvas 
            ref={this.ref} 
            width="900" 
            height='500'
          />
          {items.map((item) => <LineLabel key={'line_' + item._id} canvas={canvas} item={item} />)}
        </div>
      </div>
    )
  }
}

export default AnswerType6


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/Questions/components/Item/components/Answers/components/AnswerType6/AnswerType6.jsx